import { PersonaSize, PersonaPresence, IPersonaProps } from '@fluentui/react';
import { TimeUser } from '../api/generated/data-contracts';

export const mapUserToPersona = (user: TimeUser) => {
    return {
        imageInitials: user.name?.slice(0, 1) + (user.surname ? user.surname.slice(0, 1) : ''),
        text: user.name,
        secondaryText: user.userNumber ?? user.jobTitle ?? '',
        showSecondaryText: true,
        size: PersonaSize.size48,
        presence: PersonaPresence.none,
        imageAlt: user.name + ', ' + user.jobTitle,
        itemID: user.id,
    } as IPersonaProps;
};
